import SlugUI from '@tencent/slug-ui'
import Comment from '@tencent/comment'
import Vue from 'vue'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import infiniteScroll from 'vue-infinite-scroll'
import VueLazyload from 'vue-lazyload'
import imgUrlFormat from './filters/imgUrlFormat'
import App from './App.vue'
import router from './router'
import store from './store'
import wxTitle from './directives/wx-title'
import sticky from './directives/sticky'
import wxShare from './utils/wxShare'

import './assets/styles/global.scss'

Vue.config.productionTip = false

Vue.directive('title', wxTitle)
Vue.directive('sticky', sticky)
Vue.use(SlugUI)
Vue.use(Comment)
Vue.use(infiniteScroll)
Vue.use(wxShare)
Vue.use(VueLazyload, {
  preLoad: 1.2,
  attempt: 1,
  filter: {
    imgUrl(listener, options) {
      const param = {}
      if (options.supportWebp) {
        param.format = 'webp'
      }
      if (listener.el.dataset.w) {
        param.w = listener.el.dataset.w
      }
      listener.src = imgUrlFormat(listener.src, param)
    },
  },
})

const comment = new Comment({
  options: {
    gameid: 'gzh_news', // 游戏 id
    // stime: '201906', // 当前资源的创建时间，年月即可
    // objid: '15232680', // 当前资源的自定义 id，需保证唯一性
    moduleId: 'gzh_news', // 当前资源所属的业务模块 id
  },
  login: {
    wxappid: 'wxa817069bb040f860',
  },
})
if (process.env.NODE_ENV === 'production') {
  Raven
    .config('https://e43229b0eef44b0bbda2bc220e977739@report.url.cn/sentry/1392')
    .addPlugin(RavenVue, Vue)
    .install()
}


new Vue({
  router,
  store,
  comment,
  render: h => h(App),
}).$mount('#app')
